module.exports = __webpack_public_path__ + "img/4.62e46343.jpg";